export default __webpack_public_path__ + "static/media/attentionbasic_logo.d0744573.jpeg";